import { z } from "zod";

/**
 * What a role write may carry: the name, and nothing else. `id`, `orgId` and `isSystem` are
 * deliberately absent — the server derives the first two from the request and pins the third
 * to `false`, and their absence in the inferred type is what keeps a payload from ever
 * reaching those columns. The name is trimmed only; casing is the organisation's own business.
 */
export const roleSchema = z.object({
	name: z.string().trim().min(1).max(64),
});

export type RoleFormSchema = z.infer<typeof roleSchema>;
